import { gql } from '__generated__';

export const TeamFieldsFragment = gql(`
  fragment TeamFields on Team {
    id
    title
    access_code
    members {
      id
      sequence
      ticket {
        id
        title
        allow_individuals
      }
      locked
      full_name
    }
    event {
      private_teams
    }
  }
`);

export default gql(`
  query GetTeamDetails($id: ID!) {
    team(id: $id) {
      ...TeamFields
    }
  }
`);
